<template>
    <div>
        <PageBanner
            title="Form Builder"
            subtext="Create and manage dynamic forms."
            colour="orange"
        />
        <div class="q-pa-md">
            <FormManager />
        </div>
    </div>
</template>

<script>
import PageBanner from "@/components/ClientComponents/DashboardComponents/PageBanner.vue";
import FormManager from "@/components/DynamicFormComponents/FormBuilder/FormManager.vue";

export default {
    name: "form-builder-view",
    components: { PageBanner, FormManager },
    title: 'Form Builder',
};
</script>
